import React, { createContext, useEffect, useReducer } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { environment } from 'environments/environment';

// third-party
import { Chance } from 'chance';
import jwtDecode from 'jwt-decode';

// reducer - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import axios from 'utils/axios';

// types
import { KeyedObject } from 'types';
import { InitialLoginContextProps, JWTContextType } from 'types/auth';
import { UserProfile } from 'types/user-profile';
import { resetPasswordAsync } from 'service/user-service';

const chance = new Chance();

// constant
const initialState: InitialLoginContextProps = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

const verifyToken: (st: string) => boolean = (serviceToken) => {
    if (!serviceToken) {
        return false;
    }
    const decoded: KeyedObject = jwtDecode(serviceToken);
    /**
     * Property 'exp' does not exist on type '<T = unknown>(token: string, options?: JwtDecodeOptions | undefined) => T'.
     */
    //return decoded.exp > Date.now() / 1000;
    return jwtDecode(serviceToken);
};

const setSession = (serviceToken?: string | null) => {
    if (serviceToken) {
        localStorage.setItem('serviceToken', serviceToken);
        axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    } else {
        localStorage.removeItem('serviceToken');
        delete axios.defaults.headers.common.Authorization;
    }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
const JWTContext = createContext<JWTContextType | null>(null);

export const JWTProvider = ({ children }: { children: React.ReactElement }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);

    const navigate = useNavigate();

    useEffect(() => {
        const init = async () => {
            try {
                const serviceToken = window.localStorage.getItem('serviceToken');
                if (serviceToken && verifyToken(serviceToken)) {
                    console.log('we ever hit this even?');
                    setSession(serviceToken);
                    // const response = await axios.get('/api/account/me');
                    // const { user } = response.data;
                    // console.log(user);
                    // dispatch({
                    //     type: LOGIN,
                    //     payload: {
                    //         isLoggedIn: true,
                    //         user
                    //     }
                    // });
                    dispatch({
                        type: LOGOUT
                    });
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    const login = async (email: string, password: string) => {
        const response = await axios.post('/users/login', { email, password });
        const serviceToken = response.data.acessToken;
        const user: UserProfile = { id: response.data.user.Id, email: response.data.user.Email, role: response.data.user.Role };

        console.log(response.data.user);
        localStorage.setItem('user', response.data.user);
        localStorage.setItem('user_id', response.data.user.Id);
        localStorage.setItem('user_email', response.data.user.Email);
        localStorage.setItem('user_role', response.data.user.Role);
        setSession(serviceToken);
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                user
            }
        });
    };

    const existingLogin = async (user_id: string, user_email: string, user_role: string) => {
        const user: UserProfile = { id: user_id, email: user_email, role: user_role };
        console.log(user);
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                user
            }
        });
    };

    // const login = async (token: string) => {
    //     const user: UserProfile = window.localStorage.getItem('userInfo');
    //     if(user) {
    //         dispatch({
    //             type: LOGIN,
    //             payload: {
    //                 isLoggedIn: true,
    //                 user
    //             }
    //         });
    //     }
    // };

    const register = async (email: string, password: string, firstName: string, lastName: string) => {
        // todo: this flow need to be recode as it not verified
        const id = chance.bb_pin();
        //const response = await axios.post('/api/account/register', {
        const response = await axios.post(`${environment.apiBaseUrl}users/add`, {
            //id,
            email: email,
            password: password,
            //firstName,
            //lastName
            role: 'user'
        });
        let users = response.data;

        if (window.localStorage.getItem('users') !== undefined && window.localStorage.getItem('users') !== null) {
            const localUsers = window.localStorage.getItem('users');
            users = [
                ...JSON.parse(localUsers!),
                {
                    id,
                    email,
                    password,
                    name: `${firstName} ${lastName}`
                }
            ];
        }

        window.localStorage.setItem('users', JSON.stringify(users));
    };

    const logout = () => {
        setSession(null);
        dispatch({
            type: LOGOUT,
            payload: {
                isLoggedIn: false,
                user: null
            }
        });
        navigate('/login');
    };

    const resetPassword = async (email: string) => {
        await resetPasswordAsync(email);
    };

    const updateProfile = () => {};

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <JWTContext.Provider value={{ ...state, login, logout, register, resetPassword, updateProfile, existingLogin }}>
            {children}
        </JWTContext.Provider>
    );
};

export default JWTContext;
